import styled, { keyframes } from "styled-components";

export const ButtonWrapper = styled.button<{ $isLoading?: boolean }>`
  padding: 0 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.5rem;
  height: 2.25rem;
  border: none;
  flex-direction: column;
  margin-left: auto;
  width: 100%;
  cursor: ${(props) => (props.$isLoading ? "default" : "pointer")};
  background-color: transparent;
  opacity: ${(props) => (props.$isLoading ? "0" : "1")};
  z-index: 2;
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 250ms;

  &:hover {
    opacity: ${(props) => (props.$isLoading ? "0" : "0.9")};
    box-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1),
      0 4px 6px -4px rgb(0 0 0 / 0.1);
  }
`;

export const Container = styled.div`
  position: relative;
  border-radius: 0.5rem;
  height: 2.25rem;
  width: max-content;
  background-color: #e81515;
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 400ms;
`;

const spinAnimation = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

export const LoaderWrapper = styled.div<{ $isLoading?: boolean }>`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: ${spinAnimation} 1s linear infinite;
  height: 1.5rem;
  width: 1.25rem;
  visibility: ${(props) => (props.$isLoading ? "visible" : "hidden")};
  opacity: ${(props) => (props.$isLoading ? "1" : "0")};
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 250ms;
`;
